import FlexBox from "design-system/src/Components/FlexBox/FlexBox";
import React from "react";
import Typography from "design-system/src/Foundation/Typography/Typography";
import { useTranslation } from "@src/hooks/useTranslation";
import { _AccountOrderButtonWrapper } from "../GameParticipationModal.styled";
import Button from "design-system/src/Foundation/Button/Button";

interface IParticipationStep1Props {
  onOpenForm?: () => void;
}

const ParticipationStep1 = (props: IParticipationStep1Props) => {
  const { onOpenForm } = props;
  const { t } = useTranslation(["Pacman"]);
  return (
    <FlexBox direction="column" align="center">
      <FlexBox direction="column" align="center">
        <Typography variant="subtitle2" mb={16} align="center">
          {t(
            "Tentez de remporter un repas pour deux en vous inscrivant simplement à notre formulaire de participation.",
            "Pacman"
          )}
        </Typography>
        <Typography
          variant="subtitle2"
          mb={24}
          align="center"
          color="greyText2"
        >
          {t("Tirage au sort le 01/01/0001 à 12:00 (heure de paris)", "Pacman")}
        </Typography>
      </FlexBox>

      <_AccountOrderButtonWrapper mt={24}>
        <Button
          style={{ position: "relative" }}
          type="submit"
          color={"primary"}
          onClick={onOpenForm}
        >
          {t("Voir le formulaire", "Pacman")}
        </Button>
      </_AccountOrderButtonWrapper>
    </FlexBox>
  );
};

export default ParticipationStep1;
